import { render, staticRenderFns } from "./goods.vue?vue&type=template&id=0e7bc6b7&scoped=true&"
import script from "./goods.vue?vue&type=script&lang=js&"
export * from "./goods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7bc6b7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\ssz_gold_backend\\multi_merchant_web\\gold_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e7bc6b7')) {
      api.createRecord('0e7bc6b7', component.options)
    } else {
      api.reload('0e7bc6b7', component.options)
    }
    module.hot.accept("./goods.vue?vue&type=template&id=0e7bc6b7&scoped=true&", function () {
      api.rerender('0e7bc6b7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/lease/goods.vue"
export default component.exports